var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.onClickOutside,
          expression: "onClickOutside",
        },
      ],
      staticClass: "layer-context-menu",
    },
    _vm._l(_vm.options, function (option, index) {
      return _c(
        "li",
        {
          key: index,
          staticClass: "layer-context-menu__item",
          class: [
            option.class,
            option.type === "divider" ? "layer-context-menu__divider" : "",
          ],
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.optionClicked(option)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "layer-context-menu__item-icon" },
            [
              _c("SvgIcon", {
                attrs: {
                  size: "14",
                  type: "mdi",
                  path: option.icon || _vm.defaultIconMenu,
                },
              }),
            ],
            1
          ),
          _c("span", { domProps: { innerHTML: _vm._s(option.name) } }),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }